import axios from "axios";
import { FETCH_UNAVAILABILITIES, HANDLE_ERRORS, LOADING_MODE } from "./types";
import BASE_URL from '../helpers/base-url';
import authorizeRequest from "../helpers/authorize-request";

export const getUnavailabilities = () => async dispatch => {
  try {
    dispatch({ type: LOADING_MODE, payload: true, meta: { type: 'unavailabilities' } });

    const response = await axios.get(
      `${BASE_URL}/api/file/unavailabilities`,
      authorizeRequest()
    );

    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: "", open: false }
    });
    await dispatch({
      type: FETCH_UNAVAILABILITIES,
      payload: response
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'unavailabilities' } });
  } catch (error) {
    console.error("error fetching ems unavailabilites", error);
    dispatch({
      type: HANDLE_ERRORS,
      payload: { message: error.message, open: true }
    });
    dispatch({ type: LOADING_MODE, payload: false, meta: { type: 'unavailabilities' } });
  }
};



// WEBPACK FOOTER //
// ./src/actions/getUnavailabilities.js